import { BriefcasePlusOutlineIcon } from './BriefcasePlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id CA6D7ED5-38E6-4B63-915A-431CDDA27062
 * name briefcase-plus-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-plus-outline.svg
 * tags
 */
export const BriefcaseAddOutlineIcon = BriefcasePlusOutlineIcon;
export default BriefcaseAddOutlineIcon